import React from "react";
import {
  Button,
  Segment,
  Menu,
  Dropdown,

} from "semantic-ui-react";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { logoutAction } from "../actions/index";
import { isLoggedIn, isAdmin } from "../util";
import { withRouter } from "react-router";
import MainView from "./Maincomponents/MainView.jsx";
import matrix from "../Images/matrix-logo.png";
import TabView from "./Maincomponents/TabView.jsx";


class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      userdetail: false,
      card: "",
      visible: true,
      modalopen:false,
      code:''
    };
  }

  componentWillMount() {
    console.log("WIll mount Home")
    if (!isLoggedIn(this.props.auth)) {
      this.props.history.push(`/login`);
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    console.log("should Update Home")
    if (!isLoggedIn(nextProps.auth)) {
      this.props.history.push(`/login`);
      return false;
    }
    return true;
  }

  logout = () => {
    let email = this.props.auth.email;
    this.props.logout(email);
  };
  control = () => {
    this.props.history.push("/controlpanel");
  };
  userDetail = () => {
    this.setState({
      userdetail: true,
    });
  };


  render() {   
    console.log(this.props.auth,'authhhh')
    return (
      <div style={{ height: "100%" }}>
        <Segment raised style={{ backgroundColor: "#ffffff", height: 60 }}>
          <div style={{ display: "inline-block" }}>
            <img
              style={{
                height: 60,
                marginTop: -13,
                float: "left",
              }}
              src={matrix}
            />
          </div>

          <Menu.Menu
            style={{
              display: "inline",
              float: "right",
              marginTop: 8,
              marginRight: 50,
            }}
          >
            <Dropdown pointing text={this.props.auth.location}>
              <Dropdown.Menu>
                
                {isAdmin(this.props.auth) && (
                  <Dropdown.Item onClick={this.control}>
                    Control Panel
                  </Dropdown.Item>
                )}
                              
                <Dropdown.Item onClick={this.logout}>Logout</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </Menu.Menu>
        </Segment>
        <Segment
          basic
          style={{
            height: "100vh",
            display: "flex",
            padding: "10px 0px 0px 0px",
            backgroundColor: "white",
            overflowY: "scroll",
          }}
        >
          <TabView token={this.props.auth.accessToken} />
        </Segment> 
       
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      logout: logoutAction,
    },
    dispatch
  );
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Home));
